import { Game } from '../game.model';
import { Player } from '../player.model';

export class Spectated {
  game: Game;
  player: Player;
}
